// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.static-menu-content {\n  display: grid;\n  align-content: center;\n  justify-content: flex-start;\n  grid-auto-columns: auto;\n  min-width: 100%;\n  max-width: 590px;\n  padding-top: 5px;\n  padding-bottom: 25px;\n  grid-auto-flow: column;\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
